import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-8% 0px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClass = "", delay = 0, stagger = 0.1, play = true, inView = false }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "115%", rotate: 2 }}
          {...(inView
            ? { whileInView: { y: 0, rotate: 0 }, viewport: { once: true, margin: "-10% 0px" } }
            : { animate: play ? { y: 0, rotate: 0 } : { y: "115%", rotate: 2 } })}
          transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const Pop = ({ children, delay = 0, className = "", play = true, rotate = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, scale: 0.6, rotate: rotate - 8 }}
    animate={play ? { opacity: 1, scale: 1, rotate } : {}}
    transition={{ type: "spring", stiffness: 260, damping: 18, delay }}
  >
    {children}
  </motion.div>
);
